(() => {
const W=1672,H=941;
const pointInside=(x,y,poly)=>{let inside=false;for(let i=0,j=poly.length-1;i<poly.length;j=i++){const a=poly[i],b=poly[j];if((a[1]>y)!==(b[1]>y)&&x<(b[0]-a[0])*(y-a[1])/(b[1]-a[1])+a[0])inside=!inside;}return inside;};
const bounds=poly=>({left:Math.min(...poly.map(p=>p[0])),right:Math.max(...poly.map(p=>p[0])),top:Math.min(...poly.map(p=>p[1])),bottom:Math.max(...poly.map(p=>p[1]))});
const rect=(l,t,r,b,vertical=false,variant=0)=>({quad:[[l,t],[r,t],[r,b],[l,b]],vertical,variant});
const defaultBodies=[[[386,203],[1283,203],[1283,750],[1289,760],[1288,796],[381,796],[380,759],[387,748]],[[38,320],[350,320],[369,299],[369,689],[381,689],[381,748],[360,794],[29,794],[30,744],[39,734]],[[1315,320],[1634,320],[1634,734],[1642,744],[1642,794],[1313,794],[1290,748],[1290,690],[1305,690],[1305,299]]];
const defaultTops=[[[368,174],[415,128],[1254,128],[1301,173],[1300,202],[369,202]],[[21,294],[68,253],[375,253],[375,280],[350,319],[22,319]],[[1294,253],[1603,253],[1649,292],[1649,318],[1320,318],[1294,280]]];
const defaultPoints=[[546,277],[833,277],[1120,277],[617,417],[1055,417],[617,557],[1055,557],[617,693],[1055,693],[192,389],[192,529],[192,670],[1487,389],[1487,529],[1487,670]];
const surfacesFor=config=>{
 if(config.woodSurfaces?.length)return config.woodSurfaces.map((s,i)=>({...s,variant:s.variant??i%3}));
 if(Number(config.productId)===15441000202328){
  const pieces=[rect(687.83,158.57,990.02,802.58,true),rect(680.68,802.58,997.82,827.92,false,5)];
  [[162,273],[287,405],[422,536],[550,660],[677,790]].forEach(([top,bottom],i)=>{
   pieces.push(rect(710,top,968,bottom,false,i%3));
   pieces.push(rect(710,top,730,bottom,true),rect(946,top,968,bottom,true));
  });
  pieces.push(rect(672.23,128,1006.26,158.57,false,4),{quad:[[711.88,110.48],[965.97,110.48],[1006.26,127.37],[672.23,128.02]],vertical:false,variant:4});
  return pieces;
 }
 const surfaces=[];
 for(const poly of config.bodyPolygons||defaultBodies){
  const b=bounds(poly),width=b.right-b.left,height=b.bottom-b.top;
  surfaces.push(rect(b.left,b.top,b.right,b.bottom,true));
  const points=(config.handlePoints||defaultPoints).filter(([x,y])=>pointInside(x,y,poly)).sort((a,b)=>a[1]-b[1]);
  const rows=[];
  for(const p of points){let row=rows.find(r=>Math.abs(r.y-p[1])<Math.max(12,height*.025));if(!row){row={y:p[1],points:[]};rows.push(row);}row.points.push(p);row.y=row.points.reduce((sum,q)=>sum+q[1],0)/row.points.length;}
  const left=b.left+width*.045,right=b.right-width*.045;
  rows.forEach((row,ri)=>{
   row.points.sort((a,b)=>a[0]-b[0]);
   const gapBefore=ri?row.y-rows[ri-1].y:rows[1]?rows[1].y-row.y:height*.75;
   const gapAfter=ri+1<rows.length?rows[ri+1].y-row.y:gapBefore;
   const top=Math.max(b.top+height*.012,row.y-gapBefore*.40),bottom=Math.min(b.bottom-height*.055,row.y+gapAfter*.45);
   row.points.forEach((p,ci)=>{
    const l=ci?(row.points[ci-1][0]+p[0])/2+width*.008:left;
    const r=ci+1<row.points.length?(p[0]+row.points[ci+1][0])/2-width*.008:right;
    surfaces.push(rect(l,top,r,bottom,false,(ri*2+ci)%3));
    const rail=Math.min((r-l)*.045,(bottom-top)*.12);
    surfaces.push(rect(l,top,l+rail,bottom,true),rect(r-rail,top,r,bottom,true));
   });
  });
  surfaces.push(rect(b.left,b.bottom-height*.055,b.right,b.bottom,false,5));
 }
 for(const poly of config.topPolygons||defaultTops){const b=bounds(poly);surfaces.push(rect(b.left,b.top,b.right,b.bottom,false,4));if(poly.length>=6){const frontY=(poly[0][1]+poly[3][1])/2;surfaces.push({quad:[poly[1],poly[2],[poly[3][0],frontY],[poly[0][0],frontY]],vertical:false,variant:4});}}
 return surfaces;
};
const makeMap=(config,swatches,reference)=>{
 const c=document.createElement('canvas');c.width=reference.naturalWidth||reference.width;c.height=reference.naturalHeight||reference.height;
 const cx=c.getContext('2d',{willReadFrequently:true});cx.drawImage(reference,0,0);
 const source=cx.getImageData(0,0,c.width,c.height).data;
 const patches=[[400,235,450,165],[400,565,450,155],[400,900,450,140],[291,205,36,850],[300,90,650,48],[275,1135,690,40]];
 const means=patches.map(([x,y,w,h])=>{const sums=[0,0,0];for(let yy=y;yy<y+h;yy++)for(let xx=x;xx<x+w;xx++){const p=(yy*c.width+xx)*4;for(let k=0;k<3;k++)sums[k]+=source[p+k];}return sums.map(v=>v/(w*h));});
 const tones={};
 for(const [key,data] of Object.entries(swatches)){const sums=[0,0,0];for(let i=0;i<data.length;i+=4)for(let k=0;k<3;k++)sums[k]+=data[i+k];tones[key]=sums.map(v=>v/(data.length/4));}
 const topFace=new Uint8Array(W*H);
 if(Number(config.productId)===7880361640024){
  const faces=(config.woodSurfaces||[]).filter(s=>s.seed===77||s.seed===432);
  for(const face of faces){const box=bounds(face.quad);for(let y=Math.max(0,Math.floor(box.top));y<=Math.min(H-1,Math.ceil(box.bottom));y++)for(let x=Math.max(0,Math.floor(box.left));x<=Math.min(W-1,Math.ceil(box.right));x++)if(pointInside(x+.5,y+.5,face.quad))topFace[y*W+x]=1;}
 }
 const map=new Int32Array(W*H);map.fill(-1);const patchIds=new Uint8Array(W*H);
 let count=0;
 for(const surface of surfacesFor(config)){
  const [p0,p1,p2,p3]=surface.quad;
  const dx1=p1[0]-p2[0],dx2=p3[0]-p2[0],dy1=p1[1]-p2[1],dy2=p3[1]-p2[1],sx=p0[0]-p1[0]+p2[0]-p3[0],sy=p0[1]-p1[1]+p2[1]-p3[1];
  const det=dx1*dy2-dx2*dy1;if(Math.abs(det)<.001)continue;
  const g=(sx*dy2-dx2*sy)/det,h=(dx1*sy-sx*dy1)/det,a=p1[0]-p0[0]+g*p1[0],b=p3[0]-p0[0]+h*p3[0],d=p1[1]-p0[1]+g*p1[1],e=p3[1]-p0[1]+h*p3[1];
  const box=bounds(surface.quad),id=surface.vertical?3:(surface.variant||0),[px,py,pw,ph]=patches[id];
  for(let y=Math.max(0,Math.floor(box.top));y<=Math.min(H-1,Math.ceil(box.bottom));y++)for(let x=Math.max(0,Math.floor(box.left));x<=Math.min(W-1,Math.ceil(box.right));x++){
   const A=a-x*g,B=b-x*h,C=x-p0[0],D=d-y*g,E=e-y*h,F=y-p0[1],div=A*E-B*D;if(Math.abs(div)<.00001)continue;
   const u=(C*E-B*F)/div,v=(A*F-C*D)/div;if(u<0||u>1||v<0||v>1)continue;
   const xx=Math.min(c.width-1,px+Math.round(u*(pw-1))),yy=Math.min(c.height-1,py+Math.round(v*(ph-1))),idx=y*W+x;
   map[idx]=(yy*c.width+xx)*4;patchIds[idx]=id;count++;
  }
 }
 const topGrain=new Float32Array(W*H);
 if(topFace.some(Boolean)){
  const [px,py,pw,ph]=patches[3],stride=pw+1,integral=new Float64Array((pw+1)*(ph+1));
  for(let y=0;y<ph;y++){let row=0;for(let x=0;x<pw;x++){const p=((py+y)*c.width+px+x)*4;row+=.2126*source[p]+.7152*source[p+1]+.0722*source[p+2];integral[(y+1)*stride+x+1]=integral[y*stride+x+1]+row;}}
  for(let i=0;i<topFace.length;i++)if(topFace[i]&&map[i]>=0){const p=map[i],sx=p/4%c.width-px,sy=Math.floor(p/4/c.width)-py;
   if(sx<0||sx>=pw||sy<0||sy>=ph){topGrain[i]=1;continue;}
   const l=Math.max(0,sx-5),r=Math.min(pw,sx+6),t=Math.max(0,sy-22),b=Math.min(ph,sy+23),mean=(integral[b*stride+r]-integral[t*stride+r]-integral[b*stride+l]+integral[t*stride+l])/((r-l)*(b-t));
   topGrain[i]=Math.max(.85,Math.min(1.15,(.2126*source[p]+.7152*source[p+1]+.0722*source[p+2])/Math.max(1,mean)));
  }
 }
 return {map,source,patchIds,means,tones,count,topFace,topGrain,version:'approved-photo-pieces-clean-tops-20261021'};
};
window.MGRWood={makeMap};
})();


